var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "2e7161b0a6ef5996ea6029805218b9842272d7b8"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["ecommerce-rms-rodi-es@rodi"] = {
  id: "2e7161b0a6ef5996ea6029805218b9842272d7b8"
};